import { types } from "../types/types";

const initialState = {
    checking: true,
    products: [],
    profile: {} // aquí podemos guardar nombre, email, dirección, etc.
};

export const userReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.userSetProducts:
            return {
                ...state,
                checking: false,
                products: action.payload,
            };
        case types.userSetProfile:
            return {
                ...state,
                checking: false,
                profile: action.payload,
            };
        case types.userLogout:
            return {
                checking: false,
                products: [],
                profile: {},
            };
        default:
            return state;
    }
};
